import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Divider, Tooltip } from 'antd';
import { useThemeToken } from '@/hooks';
import { AppButton, Flex } from '@/components';
import { UserOutlined } from '@ant-design/icons';

export interface RoomCardSolitaryProps {
  room: DormitoryFloorRoomEntity;
  onSelectRoom: () => void;
  onShowMembers: () => void;
  isSelected: boolean;
}

export default function RoomCardSolitary({
  room,
  onShowMembers,
  onSelectRoom,
  isSelected
}: RoomCardSolitaryProps) {

  const [t] = useTranslation(['common', 'dormitory']);
  const { colorPrimaryLight, colorPrimary } = useThemeToken();
  const isFull = (room.roomSize - room.personCount) <= 0;

  const styles: CSSProperties = isSelected ? {
    backgroundColor: colorPrimaryLight,
    border: `2px solid ${colorPrimary}`
  } : { border: '2px solid transparent' };

  return (
    <Col className="min-h-[200px]" xxl={6} lg={8} md={8} sm={12} xs={24}>
      <Card
        size="small"
        className="shadow-sm !h-full"
        styles={{ body: { height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '10px', ...styles } }}
      >
        <Flex direction="column">
          <span>{t('dormitory:labels.room-code')}: {room.code}</span>
          <span>{t('dormitory:labels.members-count')}: {room.personCount}</span>
          <span>{t('common:labels.capacity')}: {room.roomSize}</span>
        </Flex>
        <Divider className="!mt-auto" />
        <Flex>
          <AppButton
            size="middle"
            type="primary"
            disabled={isFull || isSelected}
            className="w-full h-[35px]"
            onClick={onSelectRoom}>
            {t('common:labels.select')}
          </AppButton>
          <Tooltip title={t('dormitory:labels.show-members')}>
            <AppButton
              size="middle"
              onClick={onShowMembers}
              disabled={onShowMembers == null}
              className="text-base w-[35px] h-[35px]"
            >
              <Flex justify="center" align="center">
                <UserOutlined />
              </Flex>
            </AppButton>
          </Tooltip>
        </Flex>
      </Card>
    </Col>
  );
}
